
export const startShorten = () => ({
  type: 'SHORTEN_START'
});

export const finishedShorten = response => ({
  type: 'SHORTEN_SUCCESS',
  response
});

export const failedShorten = response => ({
  type: 'SHORTEN_FAILED',
  response
});


// WEBPACK FOOTER //
// ./src/actions/shorten.jsx